// removed by extract-text-webpack-plugin
module.exports = {"place":"place__6eQXe","content":"content__4tQfQ","rating":"rating__25X3I"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Charger/components/Places/Place/styles.scss
// module id = ./app/scripts/views/App/views/Charger/components/Places/Place/styles.scss
// module chunks = 1